import * as echarts from 'echarts';
import { useEffect, useRef } from 'react';

export function EChart(props: {
  option: echarts.EChartsOption;
  height?: number;
}) {
  const { option, height = 280 } = props;
  const chart_ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = chart_ref.current;

    if (!element) {
      return;
    }

    const chart = echarts.init(element, 'dark');
    chart.setOption(option);

    const resize_observer = new ResizeObserver(() => {
      chart.resize();
    });

    resize_observer.observe(element);

    return () => {
      resize_observer.disconnect();
      chart.dispose();
    };
  }, [option]);

  return <div ref={chart_ref} style={{ height, width: '100%' }} />;
}
